export const OtpProviderEndpoints = {
  LIST: '/api/admin/otpProviders',
  ACTIVATE: '/api/admin/otpProviders/:id/activate',
};
